export const LOGIN_STATUSES_CAN_LOGIN = new Set([
	'Employee',
	'Legacy',
	'Contact',
	'Approved Lead',
]);

/** MUI Typography `color` does not support `success`; use via `sx.color` (e.g. success.main). */
export const getLoginStatusTypographyColor = (status) =>
	LOGIN_STATUSES_CAN_LOGIN.has(status) ? 'success.main' : 'error.main';
